import { ACCEPT_FIRST_TIME } from "./actionTypes";

export default () => ({
  type: ACCEPT_FIRST_TIME,
  payload: {

  },
});
